"use client";

import { PilotProgramPage } from "@/components/shared/pilot-program-page";
import { BenefitsRow } from "@/components/shared/benefits_row";

const requirements = [
  {
    title: "Engaged Faculty",
    description: "1-3 departments open to exploring and piloting new AI technologies."
  },
  {
    title: "Executive Support",
    description: "Involve a senior sponsor (e.g., President, Director of Teaching and Learning, CIO) to help define the pilot evaluation."
  },
  {
    title: "Clear Objectives",
    description: "Designed for institutions that want to enrich their teaching and learning in both in-class and online settings."
  },
  {
    title: "Feedback Loop",
    description: "Commitment to gathering and sharing student/faculty feedback throughout the pilot to include in the evaluation report."
  },
  {
    title: "Year-Long Evaluation",
    description: "Our 1-2 semester pilot provides time to evaluate impact and make informed decisions about wider implementation."
  },
  {
    title: "Pilot Budget",
    description: "A modest pilot fee covers our year-long support, all integrations, and pilot evaluation study."
  }
];

export default function PilotProgramEDUCAUSE25() {
  return (
    <PilotProgramPage
      variant="educause"
      title={<>Join Our EDUCAUSE<br />2026 Pilot Programme</>}
      subtitle="Ready to close your teaching and learning loop? StudyStash delivers secure, AI-powered learning within institutional guardrails."
      caseStudyLink="/about/case-studies/university-of-birmingham"
      caseStudyImage="/uob_studystash.png"
      caseStudyAlt="University of Birmingham StudyStash Case Study"
      reportImage="/uob_studystash_right.png"
      reportAlt="University of Birmingham StudyStash Report"
      whyPilotTitle="Hear Why Institutions Pilot"
      institutionType="institution"
      requirements={requirements}
      additionalContent={{
        heading: "Why Partner with StudyStash?",
        paragraph: "The EDUCAUSE 2026 Pilot is more than a trial run; it's a chance to transform the way your institution approaches digital teaching and learning.",
        benefits: [
          "Low Cost",
          "Low Risk", 
          "Faculty Friendly"
        ],
        additionalSections: [],
        unlockSection: {
          heading: "Proven Return on Investment",
          paragraph: "Our partner institutions see measurable improvements that matter. We help students achieve better grades, boost pass rates, and ultimately increase retention - all while supporting teachers with their workload. We'll work with you to measure pilot outcomes and evaluate impact",
          image: "/stock8.jpg",
          imageAlt: "Professional collaboration and partnership"
        },
        pilotSection: {
          heading: "Low Risk, Low Cost",
          paragraph: "Running a pilot is a low-risk, low-cost way to explore GAI at your institution. No initial integration is required, and with your dedicated Customer Success Manager guiding the process, our pilots are frictionless - so you can test, measure, and see impact without adding to your workload.",
          image: "/lecturer-classroom.jpg",
          imageAlt: "Lecturer in classroom setting"
        },
        benefitsRow: {
          heading: "",
          description: "",
          cards: [
            {
              title: "For Students",
              bulletPoints: [
                {
                  icon: "/icon-pack/StudyStash - Icon - Graph.png",
                  text: "Improved outcomes"
                },
                {
                  icon: "/icon-pack/StudyStash - Icon - Chat.png", 
                  text: "Improved engagement"
                },
                {
                  icon: "/icon-pack/StudyStash - Icon - Home.png",
                  text: "Improved study confidence"
                }
              ],
              image: "/stock8.jpg",
              imageAlt: "Students in classroom with instructor",
              bgColor: "bg-ss-blue"
            },
            {
              title: "For Instructors",
              bulletPoints: [
                {
                  icon: "/icon-pack/StudyStash - Icon - Home.png",
                  text: "Faculty-friendly"
                },
                {
                  icon: "/icon-pack/StudyStash - Icon - Pen.png",
                  text: "Reduced workload"
                },
                {
                  icon: "/icon-pack/StudyStash - Icon - Chat.png",
                  text: "Real-time insights"
                }
              ],
              image: "/lecturer-classroom.jpg",
              imageAlt: "Instructor teaching in classroom",
              bgColor: "bg-ss-green"
            },
            {
              title: "For Universities",
              bulletPoints: [
                {
                  icon: "/icon-pack/StudyStash - Icon - Arrow.png",
                  text: "No obligation pilot"
                },
                {
                  icon: "/icon-pack/StudyStash - Icon - Lock.png",
                  text: "Low-risk, low-cost"
                },
                {
                  icon: "/icon-pack/StudyStash - Icon - Graph.png",
                  text: "Boost reputation"
                }
              ],
              image: "/stock_3.jpg",
              imageAlt: "Student studying and writing",
              bgColor: "bg-ss-purple"
            }
          ]
        }
      }}
    />
  );
}
